
import { Component, Prop, Provide, Vue } from 'vue-property-decorator'
import { apiShopLists } from '@/api/shop'
import { apiGetSupplyShopList } from '@/api/model'
@Component
export default class Dialog extends Vue {
    $refs!: { dataTable: any };
    visible = {
        val: false
    }

    page_no = 1
    list: any = []
    count = 0
    selected: any[] = []
    searchForm = {
        shop_info: ''
    }
    @Provide('visible')
    visibleVal = this.visible
    // props
    @Prop({ default: '600px' }) width!: string | number //弹窗的宽度
    @Prop({ default: 30 }) PageSize!: string | number //每页显示条数
    @Prop({ default: 1 }) type!: string | number //
    @Prop({ default: 1 }) model_id!: string | number //
    @Prop({ default: () => [] }) supplySid!: any //供应商ID数组
    // data

    // methods
    handleEvent(type: 'cancel' | 'confirm') {
        this.$emit(type)
        this.close()
    }

    onTrigger() {
        this.open()
        this.getShopList()
    }
    changePage(val: number) {
        this.page_no = val
        this.getShopList()
    }
    getShopList() {
        if (this.type == 1) {
            apiShopLists({ page_size: this.PageSize, page_no: this.page_no, shop_info: this.searchForm.shop_info }).then((res: any) => {
                this.list = res.lists.filter((item: any) => !this.supplySid.includes(item.id));
                this.count = res.count;
            })
        } else {
            apiGetSupplyShopList({ page_size: this.PageSize, page_no: this.page_no, shop_info: this.searchForm.shop_info, model_id: this.model_id }).then((res: any) => {
                this.list = res.data.filter((item: any) => !this.supplySid.includes(item.id));
                this.$nextTick(() => {
                    this.list.forEach((item: any) => {
                        if (item.is_select) {
                            this.$refs.dataTable.toggleRowSelection(item, true);
                        }
                    })
                })

            })
        }
    }
    handleSelectionChange(value: any) {
        this.selected = value
    }
    close() {
        this.visible.val = false
        this.$emit('close')
    }
    open() {
        this.visible.val = true
        this.$emit('open')
    }
}
